import { Sentry } from './lib/sentry'; // eerst: Sentry moet vóór de app geladen zijn
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/Toast';
import './styles/globals.css';

// SSO landing: Toolbox redirects naar /?toolbox_token=<jwt>. We sturen meteen
// door naar de server-endpoint zodat die de token verifieert en een sessie-cookie
// zet — de SPA hoeft de token niet zelf te zien.
{
  const params = new URLSearchParams(window.location.search);
  const tok = params.get('toolbox_token');
  if (tok) {
    window.location.replace(`/api/auth/sso?toolbox_token=${encodeURIComponent(tok)}`);
    throw new Error('redirecting to SSO'); // stop verdere init tijdens redirect
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

function CrashFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-lightgrey">
      <div className="text-center p-8">
        <h2 className="font-bold text-lg text-primary">Er liep iets mis</h2>
        <p className="mt-2 mb-4 text-sm opacity-70">De fout is automatisch gemeld. Herlaad de pagina om verder te werken.</p>
        <button onClick={() => window.location.reload()} className="px-4 py-1.5 rounded-md bg-primary text-white">Herladen</button>
      </div>
    </div>
  );
}

createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<CrashFallback />}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          <ToastProvider>
            <AuthProvider>
              <App />
            </AuthProvider>
          </ToastProvider>
        </QueryClientProvider>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
